import { useEffect } from 'react';
import { useFlow } from './hooks/useFlow';
import { useFacilityState } from './hooks/useFacilityState';

import Top from './components/Top';
import QrCodeReader from './components/QrCodeReader';
import InputNumberForm from './components/InputNumberForm';
import Finished from './components/Finished';
import ReceptionError from './components/ReceptionError';
import LINEFriendAdd from './components/LINEFriendAdd';
import FacilityIdInput from './components/FacilityIdInput';
import FacilityConfirmation from './components/FacilityConfirmation';

import { Flow } from './types/flow';

function ReceptionForm() {
  const { flow, setFlow } = useFlow();
  const { facilityId, setFacilityId, clinicName, setClinicName } = useFacilityState();

  useEffect(() => {
    if (!facilityId) {
      setFlow('facilityInput');
    }
  }, [facilityId]);

  switch (flow) {
    case 'facilityInput':
      return <FacilityIdInput onConfirm={setFacilityAndFlow(setFacilityId, setClinicName, setFlow)} />;
    case 'facilityConfirmation':
      return <FacilityConfirmation facilityId={facilityId} clinicName={clinicName} onConfirm={() => setFlow('top')} />;
    case 'top':
      return <Top clinicName={clinicName} />;
    case 'QRcodeReader':
      return <QrCodeReader clinicName={clinicName} facilityId={facilityId} />;
    case 'LINEFriendAdd':
      return <LINEFriendAdd clinicName={clinicName} />;
    case 'inputNumber':
      return <InputNumberForm clinicName={clinicName} />;
    case 'finished':
      return <Finished clinicName={clinicName} />;
    case 'error':
      return <ReceptionError clinicName={clinicName} />;
    default:
      return null;
  }
}

export default ReceptionForm;

const setFacilityAndFlow =
  (
    setFacilityId: (id: string) => void,
    setClinicName: (name: string) => void,
    setFlow: React.Dispatch<React.SetStateAction<Flow>>
  ) =>
  (facilityData: { facilityId: string; facilityName: string }) => {
    setFacilityId(facilityData.facilityId);
    setClinicName(facilityData.facilityName);
    setFlow('facilityConfirmation');
  };
